import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import checkbox from "@/assets/images/user/checkbox.svg";
import checkboxOn from "@/assets/images/user/checkboxOn.svg";

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
    txt?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ className, txt, ...props }, ref) => {
    const boxStyle = twMerge("cursor-pointer flex justify-center items-center gap-[8px]", className);

    return (
        <label className={boxStyle}>
            <input
                type={"checkbox"}
                className="hidden"
                ref={ref} // react-hook-form의 ref와 연결
                {...props}
            />
            <div className="check block size-[24px]">
                <img src={props.checked ? checkboxOn : checkbox} alt="체크박스" />
            </div>
            {txt && <span className="txt text-[16px] leading-[1] text-[#666] md:text-[18px]">{txt}</span>}
        </label>
    );
});

Checkbox.displayName = "Checkbox"; // forwardRef 사용 시 필요
export default Checkbox;
